import React from 'react'
import { T } from "react-translator-component";
import { SxProps } from "@mui/material";
import FetchButton from "../FetchButton";

interface Props {
  sx?: SxProps;
  validate: () => Promise<boolean>;
  onSubmit: () => Promise<boolean>;
}

const AggregationButton: React.FC<Props> = ({ sx, validate, onSubmit }) => {
  return (
    <FetchButton
      title={T('mng_statistics_submit')}
      sx={sx}
      validate={validate}
      onSubmit={onSubmit}
    />
  );
}
export default AggregationButton
